import collapse from '@alpinejs/collapse';
import Alpine from 'alpinejs';

// Initialize Alpine if it's not already initialized
const AlpineInstance = window.Alpine || Alpine;

if (!window.Alpine) {
  // Make Alpine globally available
  window.Alpine = Alpine;

  document.addEventListener('DOMContentLoaded', () => {
    AlpineInstance.start();
  });
}

document.addEventListener('alpine:init', () => {
  AlpineInstance.plugin(collapse);

  AlpineInstance.data('krosMegamenu', function () {
    return {
      __type: 'megamenu',
      open: false,
      isTouch: false,
      init() {
        // Is touch device
        this.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        this.$watch('open', (value) => {
          if (value) {
            // Get the panel element
            const panel = this.$refs['panel-' + this.open];
            // Get the header element
            const header = this.$el;

            // Wait for next tick to ensure panel is visible
            this.$nextTick(() => {
              // Get panel's height including its content
              const panelHeight = panel.offsetHeight;
              // Set header's height to include the panel
              header.style.height = `${panelHeight}px`;
            });
          } else {
            // Reset when closed
            this.$el.style.height = '';
          }
        });
      },
      openMegamenu(id) {
        this.open = id;
      },
      closeMegamenu(reason) {
        this.open = false;

        this.$nextTick(() => {
          // Add custom JS trigger so we can hook into the close event
          this.$el.dispatchEvent(new Event('closeMegamenu'));
        });
      },
      toggleMegamenu(id) {
        if (this.open === id) {
          this.open = false;
        } else {
          this.open = id;
        }
      },
    };
  });

  AlpineInstance.data('krosDropdown', function () {
    return {
      open: false,
      toggle() {
        if (this.open) {
          return this.close();
        }
        this.open = true;
      },
      close() {
        if (!this.open) return;
        this.open = false;
      },
    };
  });

  AlpineInstance.data('krosModal', function () {
    return {
      open: false,
      openModal(type) {
        // this.open = false;
        this.open = type;
        document
          .querySelector('.js-kross-modal-overlay')
          .classList.add('is-active');

        this.$nextTick(() => {
          this.$refs?.searchInput?.focus();
        });
      },
      toggleModal(type) {
        if (this.open === type) {
          this.closeModal();
        } else {
          this.openModal(type);
        }
      },
      closeModal() {
        this.open = false;
        document
          .querySelector('.js-kross-modal-overlay')
          .classList.remove('is-active');
      },
    };
  });
});

// Handle header on scroll
document.addEventListener('DOMContentLoaded', function () {
  const diviSticker = document.querySelector('.sticker');
  const subHeader = document.querySelector('.js-kros-sub-header');

  const headerWrapper = document.querySelector('.js-kros-megamenu-header');
  const topNav = document.querySelector('.js-kros-megamenu-top-nav');
  const headerMain = document.querySelector('.js-kros-megamenu-main');

  // If Divi sticker is present, disable main header scroll transform
  if (diviSticker) {
    return;
  }

  if (headerMain) {
    let headerBottomOffset = headerMain.offsetTop + headerMain.offsetHeight;

    if (topNav) {
      headerBottomOffset += topNav.offsetHeight;
    }

    window.addEventListener(
      'scroll',
      debounce(() => {
        calculateHeaderScrollTransform(headerWrapper, topNav);
      }),
    );
  }

  // Function with access to prevScrollpos through closure
  function calculateHeaderScrollTransform(headerWrapper, topNav) {
    const currentScrollPos = window.scrollY;

    // When subheader is present we are making it sticky
    if (subHeader) {
      if (currentScrollPos > headerWrapper.offsetHeight) {
        subHeader.classList.add('is-sticky');
      } else {
        subHeader.classList.remove('is-sticky');
      }
    } else {
      // Otherwise we are handling main header scroll transform
      if (currentScrollPos > 0) {
        headerWrapper.classList.add('is-sticky');

        // When scrolled past topNav, top nav is always hidden
        headerWrapper.style.transform = `translateY(-${topNav?.offsetHeight ?? 0}px)`;
      } else {
        headerWrapper.classList.remove('is-sticky');

        // When scrolled to top, everything is visible
        headerWrapper.style.transform = 'translateY(0)';
      }
    }
  }
});

/**
 * Debounce functions for better performance
 * Source: https://www.joshwcomeau.com/snippets/javascript/debounce/
 *
 * @param  {Function} fn The function to debounce
 * @param  {number} wait The time, in milliseconds, to wait before calling the function
 * @return {Function} The debounced function
 */
const debounce = (callback, wait = 5) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
};
